// extracted by mini-css-extract-plugin
module.exports = {"read_more":"ViewMore_read_more__IU-t7","icon":"ViewMore_icon__F_SYY"};